import { ca } from '@cian/analytics';

export enum ETrackingAction {
  Show = 'show_sopr',
  Success = 'success',
  Fail = 'fail_sopr',
  Close = 'close_sopr',
}

export enum ELabel {
  Form = 'question_form',
  Error = 'question_form_error',
}

export function trackQuestionFormAction(action: ETrackingAction, label: ELabel) {
  ca('eventSite', {
    action,
    label,
    category: 'NewbuildingReviews',
    name: 'oldevent',
    useLastProducts: true,
  });
}
